/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as c from "react";
import e from "prop-types";
import { classNames as a } from "@progress/kendo-react-common";
const i = (n) => {
  const o = {
    layout: "end",
    ...n
  }, { layout: t, children: s } = o, r = a("k-actions", "k-window-actions", "k-actions-horizontal", "k-hstack", {
    "k-justify-content-start": t === "start",
    "k-justify-content-center": t === "center",
    "k-justify-content-end": t === "end",
    "k-justify-content-stretch": t === "stretched"
  });
  return /* @__PURE__ */ c.createElement("div", { className: r }, s);
};
i.propTypes = {
  children: e.any,
  layout: e.oneOf(["start", "center", "end", "stretched"])
};
export {
  i as WindowActionsBar
};
